import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';
import { CrudService } from '~services/crud.service';
import { environment } from '~environments/environment';
import { Site } from '~models/site';

@Injectable({
  providedIn: 'root',
})
export class SitesService {
  private sites$$: BehaviorSubject<Site[]> = new BehaviorSubject<Site[]>([]);

  public get sites$(): Observable<Site[]> {
    return this.sites$$.asObservable();
  }

  constructor(private crudService: CrudService) {}

  getSites(north: number, south: number, east: number, west: number): Observable<Site[]> {
    return this.crudService.httpClientReady.pipe(
      filter((ready) => ready),
      take(1),
      switchMap(() => this.crudService.get(`${environment.api}/site`, { north, south, east, west })),
    );
  }

  getActiveSites(): Observable<Site[]> {
    return this.crudService.httpClientReady.pipe(
      filter((ready) => ready),
      take(1),
      switchMap(() => this.crudService.get(`${environment.api}/site/active_sites`)),
    );
  }

  getSiteAccountFracMine(): Observable<Site[]> {
    return this.crudService.httpClientReady.pipe(
      filter((ready) => ready),
      take(1),
      switchMap(() => this.crudService.get(`${environment.api}/site/site_account_frac_mine`)),
    );
  }

  fetchActiveSites(): void {
    this.getActiveSites().subscribe((sites) => {
      this.sites$$.next(sites);
    });
  }
}
